import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData, State } from '../../types'
import { DirectionArrow } from '../shared/DirectionArrow'
import {
    DifferenceInCases,
    StateLabel,
    StyledFlexTable,
    StyledTableCell,
    StyledTitle,
    StyledTitleWrap,
} from './JabTracker.styled'

export function TableCell({
    datakey,
    data,
    type,
}: {
    datakey: string
    data: FormattedData
    type: 'large' | 'small' | undefined
}) {
    const stateData = data[datakey as State]
    const caseDirection =
        stateData && stateData.cases.dailyDifference > 1 ? 'up' : 'down'
    // Remove total count from list on small version
    if (type === 'small' && datakey === 'AUS') {
        return <span key="AUS"></span>
    }

    return (
        <StyledTableCell key={datakey}>
            <StateLabel>{datakey === 'AUS' ? 'Total' : datakey}</StateLabel>
            <span>{numberWithCommas(stateData.cases.dailyActive)}</span>
            {stateData.cases.dailyActive !== 0 && (
                <DifferenceInCases direction={caseDirection}>
                    {DirectionArrow({
                        direction: caseDirection,
                    })}
                    {numberWithCommas(stateData.cases.dailyDifference)}
                </DifferenceInCases>
            )}
        </StyledTableCell>
    )
}

export function ActiveCasesTable({
    data,
    type,
}: {
    data: FormattedData
    type?: 'large' | 'small'
}) {
    // DTEC589 - Editorial req : Total, then WA then the rest of the states in alphabetical order
    const waAndTotal = (state: string) => state !== 'AUS' && state !== 'WA'
    const otherStates = (state: string) => state == 'AUS' || state == 'WA'

    const filteredKeys = Object.keys(data).filter(waAndTotal).sort()

    const totalAndWaKeys = Object.keys(data).filter(otherStates).sort()
    const caseDirection = data.AUS.cases.dailyDifference > 1 ? 'up' : 'down'
    return (
        <>
            <StyledTitleWrap type={type}>
                <StyledTitle>Active cases</StyledTitle>
                <p>Local active cases today</p>
            </StyledTitleWrap>
            <StyledFlexTable type={type}>
                {totalAndWaKeys.map((key) => (
                    <TableCell
                        key={key}
                        datakey={key}
                        data={data}
                        type={type}
                    />
                ))}
                {filteredKeys.map((key) => (
                    <TableCell
                        key={key}
                        datakey={key}
                        data={data}
                        type={type}
                    />
                ))}
            </StyledFlexTable>
            {/* show total case count underneath others on small version */}
            {type === 'small' && (
                <StyledTableCell>
                    <StateLabel>Total</StateLabel>
                    <span>{numberWithCommas(data.AUS.cases.dailyActive)}</span>
                    {data.AUS.cases.dailyActive !== 0 && (
                        <DifferenceInCases direction={caseDirection}>
                            {DirectionArrow({
                                direction: caseDirection,
                            })}
                            {numberWithCommas(data.AUS.cases.dailyDifference)}
                        </DifferenceInCases>
                    )}
                </StyledTableCell>
            )}
        </>
    )
}
